export const FARE_RULE_LIST_ACTION = "FARE_RULE_LIST_ACTION";
export const FARE_RULE_LIST_SUCCESS = "FARE_RULE_LIST_SUCCESS";
export const FARE_RULE_LIST_FAIL = "FARE_RULE_LIST_FAIL";
export const FARE_RULE_DELETE_TRANSLATE_SUCCESS = "FARE_RULE_DELETE_TRANSLATE_SUCCESS";

export const FARE_RULE_DETAIL_ACTION = "FARE_RULE_DETAIL_ACTION";
export const FARE_RULE_DETAIL_DELETE_ACTION = "FARE_RULE_DETAIL_DELETE_ACTION";
export const FARE_RULE_DETAIL_SUCCESS = "FARE_RULE_DETAIL_SUCCESS";
export const FARE_RULE_DETAIL_FAIL = "FARE_RULE_DETAIL_FAIL"

export const FARE_RULE_DETAIL_UPDATE_ACTION = "FARE_RULE_DETAIL_UPDATE_ACTION";
export const FARE_RULE_DETAIL_CREATE_ACTION = "FARE_RULE_DETAIL_CREATE_ACTION";

export const FARE_RULE_CREATE_TRANSLATE_ACTION = "FARE_RULE_CREATE_TRANSLATE_ACTION";
export const FARE_RULE_UPDATE_TRANSLATE_ACTION = "FARE_RULE_UPDATE_TRANSLATE_ACTION";
export const FARE_RULE_DELETE_TRANSLATE_ACTION = "FARE_RULE_DELETE_TRANSLATE_ACTION";

export const FARE_RULE_CREATE_TRANSLATE_SUCCESS = "FARE_RULE_CREATE_TRANSLATE_SUCCESS";
export const FARE_RULE_UPDATE_TRANSLATE_SUCCESS = "FARE_RULE_UPDATE_TRANSLATE_SUCCESS";
export const FARE_RULE_FAIL = "FARE_RULE_FAIL";